import {useAppDispatch} from '../store/hooks';
import {setAppDialogParams} from '../store/slices/ui';

export function useCloseDialog() {
  const dispatch = useAppDispatch();
  const closeDialog = () =>
    dispatch(
      setAppDialogParams({
        appDialogVisible: false,
        appDialogBody: undefined,
        appDialogControls: undefined,
        appDialogIcon: undefined,
        appDialogTitle: undefined,
        appDialogOnSelectLeftt: undefined,
        appDialogOnSelectRight: undefined,
        appDialogLoading: false,
      }),
    );
  return {closeDialog};
}
